import { UploadSVG } from 'common/assets';
import { Button } from 'components/elements/buttons';
import useTranslation from 'next-translate/useTranslation';
import Papa from 'papaparse';
import * as React from 'react';

export interface ParseExcelProps {
  onClick: (result: {
    data: string[][];
    errors: any[];
    meta: {
      aborted: boolean;
      cursor: number;
      delimeter: string;
      linebreak: string;
      truncated: boolean;
    };
  }) => void;
  text?: string;
  style?: React.CSSProperties;
}

export default function ParseExcel(props: ParseExcelProps) {
  const ref = React.useRef<any | undefined>();
  const value = React.useRef<any>();
  const { t } = useTranslation();
  const { text = t('common:upload_csv') } = props;

  return (
    <>
      <input
        ref={ref}
        type="file"
        accept=".csv,.xlsx,.xls"
        style={{ display: 'none' }}
        value=""
        onChange={(e) => {
          const files = e.target.files;
          if (files) {
            value.current = files;
            Papa.parse(files[0], {
              complete: (result) => {
                props.onClick(result);
              },
            });
          }
        }}
      />
      <Button
        style={props.style || { minWidth: 150, padding: '6px 24px' }}
        buttonType="secondary"
        onClick={() => {
          ref.current && ref.current.click();
        }}
        startEnhancer={(color, size) => <UploadSVG color={color} size={size} />}
      >
        {text}
      </Button>
    </>
  );
}
